class AlgoliaIconSearch extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconSearchUrl: this.getAttribute('default-icon-search-url'),
      iconSearchSize: this.getAttribute('icon-search-size'),
      iconSearchUrl: this.getAttribute('icon-search-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .aa-Autocomplete .icon-search {
        -webkit-mask-image: url(${this.settings.iconSearchUrl ? this.settings.iconSearchUrl : this.settings.defaultIconSearchUrl});
        background-color: var(--color-core-100);
        -webkit-mask-size: ${this.settings.iconSearchSize}%;
        -webkit-mask-position: center;
        -webkit-mask-repeat: no-repeat;
      }
    `
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.className = 'icon icon-search';
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    return [style, div];
  }
}

customElements.define("algolia-icon-search", AlgoliaIconSearch);